import {Component} from '@angular/core'

@Component({
  selector: 'app-header',
  styleUrls: ['./header.component.scss'],
  template: `
    <div class="title">
      Form editor
    </div>
    <div class="actions" color="primary">
      <a href="#" mat-stroked-button matTooltip="Soon available">
        Try
      </a>
      <a href="https://github.com/alexandreannic/form-editor" target="_blank" mat-icon-button color="primary">
        <mat-icon class="fab fa-github"></mat-icon>
      </a>
    </div>
  `,
})
export class HeaderComponent {

}
